module.exports = __webpack_public_path__ + "static/media/Beryl Cong.133fe7eb.jpg";